var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "stu-care-archives-record" },
    [
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "align-items": "center",
            margin: "20px 0",
          },
        },
        [
          _c(
            "span",
            { staticClass: "title", staticStyle: { "margin-right": "10px" } },
            [_vm._v("学生关爱档案记录")]
          ),
          _c("j-dict-select-tag", {
            staticStyle: { width: "200px" },
            attrs: {
              placeholder: "请选择档案记录类型",
              dictCode: "archives_record_type",
            },
            model: {
              value: _vm.careRecordType,
              callback: function ($$v) {
                _vm.careRecordType = $$v
              },
              expression: "careRecordType",
            },
          }),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: { type: "primary" },
              on: { click: _vm.changeCareRecordType },
            },
            [_vm._v("\n      查询\n    ")]
          ),
          _c(
            "a-button",
            {
              staticStyle: { "margin-left": "10px" },
              attrs: {
                disabled: !_vm.showExportBtn,
                icon: "download",
                iconPosition: "right",
                loading: _vm.exportLoading,
              },
              on: { click: _vm.exportData },
            },
            [_vm._v("\n      导出\n    ")]
          ),
        ],
        1
      ),
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading } },
        [
          _vm.timelineRecord.length
            ? _c(
                "a-timeline",
                _vm._l(_vm.timelineRecord, function (item) {
                  return _c(
                    "a-timeline-item",
                    { key: item.id },
                    [
                      _c("div", { staticClass: "timeline-title" }, [
                        _vm._v(
                          "\n          " + _vm._s(item.date) + "\n          "
                        ),
                        _c("span", [_vm._v(_vm._s(item.title))]),
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.dataType == 20,
                              expression: "item.dataType == 20",
                            },
                          ],
                          staticClass: "card-box",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "card-title" },
                            [
                              _c("div", { staticClass: "timeline-title" }, [
                                _vm._v(_vm._s(item.name)),
                              ]),
                              _c(
                                "a-button",
                                {
                                  attrs: { type: "primary" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.viewReport(item)
                                    },
                                  },
                                },
                                [_vm._v("查看详细报告")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "eval-box" },
                            [
                              _c("RadarChart", {
                                attrs: {
                                  height: "250px",
                                  chartStyle: { width: "30%" },
                                  radius: "75",
                                  tooltip: { position: "top" },
                                  fields: item.chartData?.legend,
                                  indicator: item.chartData?.indicator,
                                  dataSource: item.chartData?.data,
                                },
                              }),
                              _c(
                                "div",
                                { staticClass: "suggestion box-shadow-1" },
                                _vm._l(
                                  item.pointScoreList,
                                  function (pItem, index) {
                                    return _c("div", { key: index }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "title",
                                          staticStyle: { margin: "5px 0" },
                                        },
                                        [_vm._v(_vm._s(pItem.pointName))]
                                      ),
                                      _c("div", [
                                        _vm._v(_vm._s(pItem.suggestion)),
                                      ]),
                                    ])
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._l(item.cardList, function (innerList, index) {
                        return item.dataType == 1
                          ? _c(
                              "div",
                              { key: index, staticClass: "card-box" },
                              [
                                _vm._l(innerList, function (card) {
                                  return _c(
                                    "div",
                                    { key: card.key, staticClass: "card-item" },
                                    [
                                      _c("span", { staticClass: "card-key" }, [
                                        _vm._v(_vm._s(card.key) + "："),
                                      ]),
                                      card.type === "image"
                                        ? [
                                            card.value &&
                                            (Array.isArray(card.value)
                                              ? card.value.length
                                              : card.value)
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      "flex-wrap": "wrap",
                                                      gap: "10px",
                                                      "margin-top": "5px",
                                                    },
                                                  },
                                                  [
                                                    _vm._l(
                                                      (Array.isArray(card.value)
                                                        ? card.value
                                                        : card.value.split(",")
                                                      ).filter((i) => i),
                                                      function (file, fileIdx) {
                                                        return [
                                                          _vm.isImage(file)
                                                            ? _c("img", {
                                                                key: fileIdx,
                                                                staticStyle: {
                                                                  width: "80px",
                                                                  height:
                                                                    "80px",
                                                                  "object-fit":
                                                                    "cover",
                                                                  "border-radius":
                                                                    "4px",
                                                                  cursor:
                                                                    "pointer",
                                                                  border:
                                                                    "1px solid #eee",
                                                                },
                                                                attrs: {
                                                                  src: _vm.getImgView(
                                                                    file
                                                                  ),
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.showImgDialog(
                                                                        _vm.getImgView(
                                                                          file
                                                                        )
                                                                      )
                                                                    },
                                                                },
                                                              })
                                                            : _c(
                                                                "div",
                                                                {
                                                                  key: fileIdx,
                                                                  staticClass:
                                                                    "file-attachment",
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.handleFileClick(
                                                                          file
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("a-icon", {
                                                                    attrs: {
                                                                      type: "paper-clip",
                                                                    },
                                                                  }),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "附件" +
                                                                        _vm._s(
                                                                          fileIdx +
                                                                            1
                                                                        )
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              ),
                                                        ]
                                                      }
                                                    ),
                                                  ],
                                                  2
                                                )
                                              : _c("span", [_vm._v("无")]),
                                          ]
                                        : _c("span", {
                                            staticClass: "card-value",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                card.value || "无"
                                              ),
                                            },
                                          }),
                                    ],
                                    2
                                  )
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: item.file,
                                        expression: "item.file",
                                      },
                                    ],
                                    staticStyle: {
                                      "margin-top": "5px",
                                      color: "#1783e8",
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(item.title) + "附件"),
                                    ]),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "download-btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.downloadFile(item)
                                          },
                                        },
                                      },
                                      [_vm._v("下载")]
                                    ),
                                  ]
                                ),
                              ],
                              2
                            )
                          : _vm._e()
                      }),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: item.dataType != 20 && item.dataType != 1,
                              expression:
                                "item.dataType != 20 && item.dataType != 1",
                            },
                          ],
                          staticClass: "card-box",
                        },
                        [
                          _vm._l(item.cardList, function (card) {
                            return _c(
                              "div",
                              { key: card.key, staticClass: "card-item" },
                              [
                                _c("span", { staticClass: "card-key" }, [
                                  _vm._v(_vm._s(card.key) + "："),
                                ]),
                                card.type === "image"
                                  ? [
                                      card.value &&
                                      (Array.isArray(card.value)
                                        ? card.value.length
                                        : card.value)
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "flex-wrap": "wrap",
                                                gap: "10px",
                                                "margin-top": "5px",
                                              },
                                            },
                                            [
                                              _vm._l(
                                                (Array.isArray(card.value)
                                                  ? card.value
                                                  : card.value.split(",")
                                                ).filter((i) => i),
                                                function (file, fileIdx) {
                                                  return [
                                                    _vm.isImage(file)
                                                      ? _c("img", {
                                                          key: fileIdx,
                                                          staticStyle: {
                                                            width: "80px",
                                                            height: "80px",
                                                            "object-fit":
                                                              "cover",
                                                            "border-radius":
                                                              "4px",
                                                            cursor: "pointer",
                                                            border:
                                                              "1px solid #eee",
                                                          },
                                                          attrs: {
                                                            src: _vm.getImgView(
                                                              file
                                                            ),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.showImgDialog(
                                                                _vm.getImgView(
                                                                  file
                                                                )
                                                              )
                                                            },
                                                          },
                                                        })
                                                      : _c(
                                                          "div",
                                                          {
                                                            key: fileIdx,
                                                            staticClass:
                                                              "file-attachment",
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.handleFileClick(
                                                                  file
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c("a-icon", {
                                                              attrs: {
                                                                type: "paper-clip",
                                                              },
                                                            }),
                                                            _c("span", [
                                                              _vm._v(
                                                                "附件" +
                                                                  _vm._s(
                                                                    fileIdx + 1
                                                                  )
                                                              ),
                                                            ]),
                                                          ],
                                                          1
                                                        ),
                                                  ]
                                                }
                                              ),
                                            ],
                                            2
                                          )
                                        : _c("span", [_vm._v("无")]),
                                    ]
                                  : _c("span", {
                                      staticClass: "card-value",
                                      domProps: {
                                        innerHTML: _vm._s(card.value || "无"),
                                      },
                                    }),
                              ],
                              2
                            )
                          }),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: item.file,
                                  expression: "item.file",
                                },
                              ],
                              staticStyle: {
                                "margin-top": "5px",
                                color: "#1783e8",
                              },
                            },
                            [
                              _c("span", [_vm._v(_vm._s(item.title) + "附件")]),
                              _c(
                                "span",
                                {
                                  staticClass: "download-btn",
                                  on: {
                                    click: function ($event) {
                                      return _vm.downloadFile(item)
                                    },
                                  },
                                },
                                [_vm._v("下载")]
                              ),
                            ]
                          ),
                        ],
                        2
                      ),
                    ],
                    2
                  )
                }),
                1
              )
            : _c("EmptyData", {
                attrs: {
                  styleObj: { padding: "30px 0" },
                  loading: _vm.loading,
                },
              }),
        ],
        1
      ),
      _c("DetailedReport", { ref: "detailedReportRef" }),
      _c(
        "a-modal",
        {
          attrs: {
            hoverable: "",
            title: "查看照片",
            visible: _vm.imgboxModal,
            centered: "",
            width: "50%",
            footer: null,
          },
          on: {
            cancel: () => ((_vm.imgModelSrc = ""), (_vm.imgboxModal = false)),
          },
        },
        [
          _c("img", {
            staticStyle: { width: "100%" },
            attrs: { src: _vm.imgModelSrc, alt: "" },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }